/* FIX-GA4-COLLECTION-FUNNEL-20260714
 * Completes the GA4 ecommerce collection funnel through Shopify's app-owned Google tag.
 * Sends view_item_list and select_item only to GA4; Google Ads and Merchant Center are untouched.
 * Respects Shopify Customer Privacy API analytics consent and fails closed while consent is unknown.
 */
(function () {
  "use strict";

  var GA4_TAG_ID = "G-VFP89NK7X8";
  var STATE_KEY = "__elGa4CollectionFunnel20260714";
  var state = window[STATE_KEY] = window[STATE_KEY] || {
    listScheduled: false,
    listSent: false,
    privacyLoadRequested: false,
    lastSelectionPath: "",
    lastSelectionAt: 0
  };

  function analyticsProcessingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== "function") return false;
    try {
      return privacy.analyticsProcessingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function hasDataLayerEvent(eventName) {
    var layer = Array.isArray(window.dataLayer) ? window.dataLayer : [];
    for (var index = 0; index < layer.length; index += 1) {
      var entry = layer[index];
      if (!entry) continue;
      if (entry.event === eventName) return true;
      if (entry[0] === "event" && entry[1] === eventName) return true;
    }
    return false;
  }

  function ensureGoogleTagCommandQueue() {
    var selector = 'script[src*="googletagmanager.com/gtag/js?id=' + GA4_TAG_ID + '"]';
    if (!document.querySelector(selector)) return false;
    window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];
    if (typeof window.gtag !== "function") {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    }
    return true;
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function productName(product, variant) {
    var name = cleanText(variant && variant.name);
    var variantName = cleanText(variant && variant.public_title);
    if (variantName && name.slice(-(variantName.length + 3)) === " - " + variantName) {
      name = name.slice(0, -(variantName.length + 3));
    }
    return name || cleanText(product && product.handle).replace(/-/g, " ");
  }

  function currentContext() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var page = meta && meta.page;
    var products = meta && Array.isArray(meta.products) ? meta.products : [];
    if (!page || page.pageType !== "collection" || !products.length) return null;

    var heading = document.querySelector("main h1, h1");
    var listName = cleanText(heading && heading.textContent) || cleanText(document.title.split("|")[0]);
    var listId = "collection_" + String(page.resourceId || window.location.pathname);
    var items = [];

    products.forEach(function (product, index) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var variant = variants[0] || {};
      var handle = cleanText(product.handle);
      if (!handle) return;
      items.push({
        item_id: cleanText(variant.sku) || String(variant.id || product.id || handle),
        item_name: productName(product, variant),
        item_brand: cleanText(product.vendor),
        item_category: cleanText(product.type),
        item_variant: cleanText(variant.public_title),
        price: Number(variant.price || 0) / 100,
        index: index,
        _path: "/products/" + handle
      });
    });

    return {
      item_list_id: listId,
      item_list_name: listName,
      items: items
    };
  }

  function publicItem(item) {
    var copy = {};
    Object.keys(item || {}).forEach(function (key) {
      if (key !== "_path" && item[key] !== "") copy[key] = item[key];
    });
    return copy;
  }

  function sendEvent(eventName, context, items) {
    if (!analyticsProcessingAllowed()) return false;
    if (!ensureGoogleTagCommandQueue()) return false;
    window.gtag("event", eventName, {
      send_to: GA4_TAG_ID,
      item_list_id: context.item_list_id,
      item_list_name: context.item_list_name,
      items: items.map(publicItem)
    });
    return true;
  }

  function scheduleListView() {
    if (state.listSent || state.listScheduled || !analyticsProcessingAllowed()) return;
    state.listScheduled = true;
    var attempts = 0;

    function waitForShopifyGoogleTag() {
      attempts += 1;
      var context = currentContext();
      if (
        analyticsProcessingAllowed() &&
        context &&
        context.items.length &&
        ensureGoogleTagCommandQueue()
      ) {
        window.setTimeout(function () {
          if (state.listSent || hasDataLayerEvent("view_item_list")) return;
          state.listSent = sendEvent("view_item_list", context, context.items);
        }, 1200);
        return;
      }
      if (attempts < 80) {
        window.setTimeout(waitForShopifyGoogleTag, 250);
      } else {
        state.listScheduled = false;
      }
    }

    waitForShopifyGoogleTag();
  }

  function productLinkFromEvent(event) {
    var target = event && event.target;
    if (!target || !target.closest) return null;
    var link = target.closest("a[href*='/products/']");
    if (!link) return null;
    try {
      return { link: link, path: new URL(link.href, window.location.href).pathname.replace(/\/$/, "") };
    } catch (error) {
      return null;
    }
  }

  function sendSelection(event) {
    var match = productLinkFromEvent(event);
    if (!match || !analyticsProcessingAllowed() || !ensureGoogleTagCommandQueue()) return;
    var context = currentContext();
    if (!context) return;
    var item = context.items.find(function (candidate) {
      return candidate._path === match.path;
    });
    if (!item) return;

    var now = Date.now();
    if (state.lastSelectionPath === match.path && now - state.lastSelectionAt < 1500) return;
    state.lastSelectionPath = match.path;
    state.lastSelectionAt = now;
    sendEvent("select_item", context, [item]);
  }

  document.addEventListener("pointerdown", sendSelection, true);
  document.addEventListener("click", sendSelection, true);
  document.addEventListener("visitorConsentCollected", function (event) {
    var detail = event && event.detail;
    if (detail && detail.analyticsAllowed === true) {
      state.listScheduled = false;
      scheduleListView();
    }
  });
  document.addEventListener("shopifyCustomerPrivacyApiLoaded", function () {
    state.listScheduled = false;
    scheduleListView();
  });

  function initializePrivacyAwareMeasurement(attempt) {
    attempt = Number(attempt || 0);
    if (analyticsProcessingAllowed()) {
      scheduleListView();
      return;
    }
    if (
      !state.privacyLoadRequested &&
      window.Shopify &&
      typeof window.Shopify.loadFeatures === "function"
    ) {
      state.privacyLoadRequested = true;
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (!error) {
            state.listScheduled = false;
            scheduleListView();
          }
        }
      );
      return;
    }
    if (!state.privacyLoadRequested && attempt < 80) {
      window.setTimeout(function () {
        initializePrivacyAwareMeasurement(attempt + 1);
      }, 250);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializePrivacyAwareMeasurement, { once: true });
  } else {
    initializePrivacyAwareMeasurement();
  }
})();
